export const severities = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
} as const
